import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FileSizePipe } from '../pipes/file-size.pipe';
import { FilenamePipe } from '../pipes/filename.pipe';
import { OrderByPipe } from '../pipes/order-by.pipe';
import { TimeAgoPipe } from '../pipes/time-ago.pipe';
import { ToClassPipe } from '../pipes/to-class.pipe';
import { FilterTimerFormatsPipe } from '../pipes/filter-timer-formats.pipe';

import { FormsModule, ReactiveFormsModule, MinLengthValidator } from '@angular/forms';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ChartsModule } from 'ng2-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { SortableModule } from 'ngx-bootstrap/sortable';

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ClipboardModule } from 'ngx-clipboard';
import { ColorPickerModule } from 'ngx-color-picker';
import { CreatorAuthenticationInterceptor } from '../services/creator.auth.interceptor';

@NgModule({
	declarations: [FilenamePipe, FileSizePipe, TimeAgoPipe, ToClassPipe, OrderByPipe, FilterTimerFormatsPipe],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		CommonModule,
		HttpClientModule,
		ColorPickerModule,
		BrowserAnimationsModule,
		BsDropdownModule.forRoot(),
		DatepickerModule.forRoot(),
		TimepickerModule.forRoot(),
		PopoverModule.forRoot(),
		PaginationModule.forRoot(),
		TooltipModule.forRoot(),
		AccordionModule.forRoot(),
		TypeaheadModule.forRoot(),
		ModalModule.forRoot(),
		SortableModule.forRoot(),
		AngularMultiSelectModule,
		ClipboardModule,
		ChartsModule
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		CommonModule,
		HttpClientModule,
		ColorPickerModule,
		BrowserAnimationsModule,
		BsDropdownModule,
		DatepickerModule,
		TimepickerModule,
		PopoverModule,
		PaginationModule,
		TooltipModule,
		AccordionModule,
		TypeaheadModule,
		ModalModule,
		SortableModule,
		AngularMultiSelectModule,
		ClipboardModule,
		ChartsModule,
		FilenamePipe,
		FileSizePipe,
		TimeAgoPipe,
		ToClassPipe,
		OrderByPipe,
		FilterTimerFormatsPipe,
		MinLengthValidator
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CreatorAuthenticationInterceptor,
			multi: true
		}
	]
})
export class CreatorCoreModule {}
